import qs from 'qs';
import { normalizePath } from '.';
const pathMap = {};
const buildPathMap = (routes, namespace = '', parentPath = '') => {
    routes.forEach((route) => {
        const path = normalizePath(`${parentPath}/${route.path ?? ''}`) || '/';
        [
            path.replace(new RegExp(`^/${namespace}/?`), ''),
            ...(route.id ? [route.id] : []),
        ].forEach((id) => {
            pathMap[namespace] = pathMap[namespace] || {};
            pathMap[namespace][id] = path;
        });
        if (route.children) {
            buildPathMap(route.children, namespace, path);
        }
    });
};
const compileUrl = (path, params) => {
    const paramsCopy = { ...params };
    return path.replace(/:([a-zA-Z0-9_]+)/g, (_match, key) => {
        if (key in paramsCopy) {
            const binding = paramsCopy[key];
            delete paramsCopy[key];
            return String(binding);
        }
        throw new Error(`Binding '${key}' not found.`);
    }) + qs.stringify(paramsCopy, {
        addQueryPrefix: true,
        arrayFormat: 'brackets',
    });
};
/**
 * Generate URL to the given route by its id or path.
 */
const urlTo = (to, params = {}) => {
    // Not initialized yet. Return early w/o throwing an error.
    if (!Object.keys(pathMap).length) {
        return '';
    }
    const { groups: { namespace, route } } = (
    // Fallback: `/` is impossible name for route.
    // This regex works always, so this fallback needs only to calm down the TypeScript compiler
    to.match(/^(?:(?<namespace>.*)::)?(?<route>.*)/) || { groups: { route: '/' } });
    if (namespace !== undefined && !pathMap[namespace]) {
        throw new Error(`Namespace '${namespace}' not found.`);
    }
    const urls = [];
    for (const ns in namespace !== undefined ? { [namespace]: pathMap[namespace] } : pathMap) {
        const path = pathMap[ns][route];
        if (path !== undefined) {
            urls.push({
                ns,
                url: compileUrl(path, params),
            });
            if (process.env.NODE_ENV !== 'development') {
                break;
            }
        }
    }
    const url = urls[0]?.url;
    if (urls.length > 1) {
        console.warn(
        // eslint-disable-next-line prefer-template
        `Route '${route}' is ambiguous. Consider prefixing the route with a namespace. Did you mean one of these?\n`
            + urls.map(({ ns }, index) => `${++index}) urlTo('${ns}::${route}'[, params])`).join('\n'));
    }
    if (!url) {
        throw new Error(`Route '${route}' not found.`);
    }
    return url;
};
urlTo.pathMap = pathMap;
urlTo.addRoutes = (routes, namespace = '') => buildPathMap(routes, namespace);
export default urlTo;
